import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isCoach, isUserAdmin } from '../utils/adminUtils';

const ClientOnlyRoute = ({ children }) => {
  const { currentUser, approvedCoachUids } = useAuth();

  // Coaches (non-admin) go to admin panel; admins can use Rezervacija to book coaches
  if (currentUser && isCoach(currentUser, approvedCoachUids) && !isUserAdmin(currentUser)) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default ClientOnlyRoute;
